import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { Link } from "react-router-dom";

const AddBank = () => {
  const navigate = useNavigate();
  const [banners, setBanners] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    // Fetch banners from API on component mount
    const fetchBanners = async () => {
      try {
        const response = await axios.get("https://api.trubetx.com/banners"); // adjust base URL if needed
        setBanners(response.data);
      } catch (err) {
        console.error("Failed to fetch banners:", err);
        setError("Failed to load banners.");
      } finally {
        setLoading(false);
      }
    };

    fetchBanners();
  }, []);

   const updateBanner = (id) => {
    navigate(`/banners/edit/${id}`);
  };

 

  return (
     <main className="flex ml-0 lg:ml-[230px]  overflow-auto bg-stone-100 pb-8">
 <div className="w-full flex-1 px-5">
  <div className="my-5">
    <div className="flex items-center justify-between">
      <div className="w-auto">
        <h1 className="font mb-3 flex flex-wrap items-center text-lg font-bold text-stone-800 md:text-xl">
          Add Bank Details{" "}
        </h1>
      </div>
      <div className="w-auto" />
    </div>
    <div className="flex items-center gap-2">
      <a className="font-semibold text-cm-gray" href="/web/banking/create#">
        Banking<span className="ml-2">/</span>
      </a>
      <a className="font-semibold text-cm-gray" href="/web/banking/create#">
        Add Details
      </a>
    </div>
  </div>
  <section className="overflow-auto ">
    <form className="shagow-lg relative rounded-lg bg-white py-1">
      <div className="grid gap-5 rounded-lg  p-5 sm:grid-cols-2">
        <div>
          <div className="mantine-InputWrapper-root mantine-TextInput-root mantine-1ejqehl">
            <label
              className="mantine-InputWrapper-label mantine-TextInput-label mantine-1fzet7j"
              htmlFor=":r1:"
              id=":r1:-label"
            >
              Account Name
            </label>
            <div className="mantine-Input-wrapper mantine-TextInput-wrapper mantine-1v7s5f8 mt-4">
              <input
                className="rounded-lg py-2 w-full outline-none border px-3  mantine-Input-input mantine-TextInput-input mantine-gszoqu"
                id=":r1:"
                type="text"
                name="accountName"
                aria-invalid="false"
                defaultValue=""
              />
            </div>
          </div>
        </div>
        <div>
          <div className="mantine-InputWrapper-root mantine-TextInput-root mantine-1ejqehl">
            <label
              className="mantine-InputWrapper-label mantine-TextInput-label mantine-1fzet7j"
              htmlFor=":r3:"
              id=":r3:-label"
            >
              Account Number
            </label>
            <div className="mantine-Input-wrapper mantine-TextInput-wrapper mantine-1v7s5f8 mt-4">
              <input
                className="rounded-lg py-2 w-full outline-none border px-3  mantine-Input-input mantine-TextInput-input mantine-gszoqu"
                id=":r3:"
                type="text"
                name="accountNo"
                aria-invalid="false"
                defaultValue=""
              />
            </div>
          </div>
        </div>
        <div>
          <div className="mantine-InputWrapper-root mantine-TextInput-root mantine-1ejqehl">
            <label
              className="mantine-InputWrapper-label mantine-TextInput-label mantine-1fzet7j"
              htmlFor=":r5:"
              id=":r5:-label"
            >
              Bank Name
            </label>
            <div className="mantine-Input-wrapper mantine-TextInput-wrapper mantine-1v7s5f8 mt-4">
              <input
                className="rounded-lg py-2 w-full outline-none border px-3  mantine-Input-input mantine-TextInput-input mantine-gszoqu"
                id=":r5:"
                type="text"
                name="bankName"
                aria-invalid="false"
                defaultValue=""
              />
            </div>
          </div>
        </div>
        <div>
          <div className="mantine-InputWrapper-root mantine-TextInput-root mantine-1ejqehl">
            <label
              className="mantine-InputWrapper-label mantine-TextInput-label mantine-1fzet7j"
              htmlFor=":r7:"
              id=":r7:-label"
            >
              IFSC Code
            </label>
            <div className="mantine-Input-wrapper mantine-TextInput-wrapper mantine-1v7s5f8 mt-4">
              <input
                className="rounded-lg py-2 w-full outline-none border px-3  mantine-Input-input mantine-TextInput-input mantine-gszoqu"
                id=":r7:"
                type="text"
                name="ifscCode"
                aria-invalid="false"
                defaultValue=""
              />
            </div>
          </div>
        </div>
      </div>
      <div className="my-5 flex items-center justify-center gap-4">
        <div className="block w-max cursor-pointer   rounded-lg px-5 py-2  bg-[#228BE6] text-white  hover:bg-sky-700 ">
          <Link to="/banking" className="flex items-center gap-1">
            <svg
              stroke="currentColor"
              fill="none"
              strokeWidth={0}
              viewBox="0 0 15 15"
              height="1em"
              width="1em"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M6.85355 3.14645C7.04882 3.34171 7.04882 3.65829 6.85355 3.85355L3.70711 7H12.5C12.7761 7 13 7.22386 13 7.5C13 7.77614 12.7761 8 12.5 8H3.70711L6.85355 11.1464C7.04882 11.3417 7.04882 11.6583 6.85355 11.8536C6.65829 12.0488 6.34171 12.0488 6.14645 11.8536L2.14645 7.85355C1.95118 7.65829 1.95118 7.34171 2.14645 7.14645L6.14645 3.14645C6.34171 2.95118 6.65829 2.95118 6.85355 3.14645Z"
                fill="currentColor"
              />
            </svg>{" "}
            <div>Back</div>
          </Link>
        </div>
        <button
          className="mantine-UnstyledButton-root mantine-Button-root rounded-lg mantine-1xk8bhn"
          type="submit"
          data-button="true"
        >
          <div className="bg-[#228be6] py-2 px-4 text-white rounded-lg mantine-Button-inner">
            <span className="mantine-1ryt1ht mantine-Button-label">
              Add Record
            </span>
          </div>
        </button>
      </div>
    </form>
  </section>
</div>

</main>
  );
};

export default AddBank;
